module.exports = __webpack_public_path__ + "static/native180-d761a3413681e1e7fc604af9854208c1.png";